module.exports = __webpack_public_path__ + "static/media/new_commande.e70eb062.png";